import styled from '@emotion/styled'

export const WhiteNotification = styled.div<{inverse?: boolean}>`
  align-items: center;
  background-color: white;
  border-radius: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${props => props.inverse ? 'row-reverse' : 'row'};
  font-family: Satoshi;
  font-size: 16px;
  font-weight: 400;
  gap: 0.5rem;
  justify-content: center;
  letter-spacing: 0%;
  line-height: 24px;
  padding: 12px 24px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 12px;
  }
`
